/* This file was generated automatically. Do not edit manually. */

export enum ExternalPaymentType {
    Unspecified = 'Unspecified',
    BadDebts = 'BadDebts',
    Bacs = 'Bacs',
    WireTransfer = 'WireTransfer',
    Invoice = 'Invoice',
    ExchangeRateDifference = 'ExchangeRateDifference',
    Complimentary = 'Complimentary',
    Reseller = 'Reseller',
    ExchangeRoundingDifference = 'ExchangeRoundingDifference',
    Barter = 'Barter',
    Commission = 'Commission',
    BankCharges = 'BankCharges',
    CrossSettlement = 'CrossSettlement',
    Cash = 'Cash',
    CreditCard = 'CreditCard',
    Prepayment = 'Prepayment',
    Cheque = 'Cheque',
    Bancontact = 'Bancontact',
    IDeal = 'IDeal',
    PayPal = 'PayPal',
    GiftCard = 'GiftCard',
    LoyaltyPoints = 'LoyaltyPoints',
    ChequeVacances = 'ChequeVacances',
    OnlinePayment = 'OnlinePayment',
    CardCheck = 'CardCheck',
    PaymentHubRedirection = 'PaymentHubRedirection',
    Voucher = 'Voucher',
    MasterCard = 'MasterCard',
    Visa = 'Visa',
    Amex = 'Amex',
    Discover = 'Discover',
    DinersClub = 'DinersClub',
    Jcb = 'Jcb',
    UnionPay = 'UnionPay',
    Twint = 'Twint',
    Reka = 'Reka',
    LoyaltyCard = 'LoyaltyCard',
    PosDiningAndSpaReward = 'PosDiningAndSpaReward',
    DirectDebit = 'DirectDebit',
    DepositCheck = 'DepositCheck',
    DepositCash = 'DepositCash',
    DepositCreditCard = 'DepositCreditCard',
    DepositWireTransfer = 'DepositWireTransfer',
}
